(function($){ 
    $.LocationProvider =  function()　{ 
        this._component_name = 'location_provider';

        $.Component.call(this, $.LocationProvider);
        // this._on('ready', $.Component.bind(this, $.LocationProvider));
    };

    $.Component.create($.LocationProvider, {
        _init: function(options) {
            this._options = options || {};
            this._transformation_file = this._options.transformation || 'abdo_location/js/merc2vp.json';
            this._transformation_data = this._options.transformation_data || {};
            this._projections = [
                ["EPSG:3395","+proj=merc +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs"],
                //　日本測地系第VIII系
                ["EPSG:6676","+proj=tmerc +lat_0=36 +lon_0=138.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs"]
            ];
            
            proj4.defs(this._projections);
            projection_name =  this._options.projection || this._projections[0][0]; //first projection is the default
            this._projection = proj4('WGS84', projection_name) || null;

            this._has_lint_data = false;
            this._has_nlint_data = false;
            this._RAD2DEG = 180 / Math.PI; 
            this._PI_4 = Math.PI / 4;
            this._load_transformation(this._after_load_transformation.bind(this)); 
        },

        _after_load_transformation: function() {  
            // すでに学習しているデータを回復する
            if ('nlint_data' in this._transformation_data) {
                var obj = this._transformation_data.nlint_data || null;
                if (obj) {
                    this._restore(obj);
                    this._has_nlint_data = true;
                }
            }
            // 学習したデータがない時
            else if ('lint_data' in this._transformation_data && this._transformation_data.lint_data.length >= 2) {
                this._load_from_lint_data(this._transformation_data.lint_data);
            }

            this._has_linear_transformation = false;
            this._linear_transformation = null;
            if ('transformation' in this._transformation_data) {
                this._has_linear_transformation = true;
                this._linear_transformation = this._transformation_data.transformation;
            }

            

            this.parent._location_loaded = true;
            this._emit('ready'); 
        },

        _load_transformation: function(callback) {
            var self = this;
            var request = new XMLHttpRequest();
            request.addEventListener('load', function(evt) {
                if (request.status == 0 || (request.status >= 200 && request.status < 400)) {
                    self._transformation_data = JSON.parse(this.responseText);  
                    callback();
                }
            });

            request.open('GET', this._transformation_file, true);
            request.send(); 
        }, 

        vp2lonlat: function(x, y) {
            if (this._projection) {
                var merc_x, merc_y, lonlat;

                if (this._has_linear_transformation) {
                    merc_x = this._x2mercx(x);
                    merc_y = this._y2mercy(y);

                    lonlat = this._projection.inverse([merc_x, merc_y]); 
                    return [lonlat[0], lonlat[1]];
                }
                else if (this._has_nlint_data) {
                    merc_x = this._unscale($.gp.predict(x,y,this._xy2mercx_model), this._min_proj_x, this._max_proj_x);
                    merc_y = this._unscale($.gp.predict(x,y,this._xy2mercy_model), this._min_proj_y, this._max_proj_y);

                    lonlat = this._projection.inverse([merc_x, merc_y]); 
                    return [lonlat[0], lonlat[1]];
                } 
                return [x, y];
            } 
            
            return false; 
            
        }, 
        
        lonlat2vp: function(lon, lat) {
            if (this._projection) {  
                var merc_xy = this._projection.forward([lon, lat]);
                if (this._has_linear_transformation) {
                    return [this._mercx2x(merc_xy[0]), this._mercy2y(merc_xy[1])];
                }
                else if (this._has_nlint_data) {
                    merc_xy[0] = this._scale(merc_xy[0], this._min_proj_x, this._max_proj_x);
                    merc_xy[1] = this._scale(merc_xy[1], this._min_proj_y, this._max_proj_y);

                    var x = $.gp.predict(merc_xy[0],merc_xy[1],this._mercxy2x_model);
                    var y = $.gp.predict(merc_xy[0],merc_xy[1],this._mercxy2y_model);

                    // var xvar = $.gp._variance(merc_xy[0],merc_xy[1],this._mercxy2x_model);
                    // var yvar = $.gp._variance(merc_xy[0],merc_xy[1],this._mercxy2y_model);
                    
                    // var total_var = Math.sqrt(xvar*(this._max_proj_x - this._min_proj_x)) + Math.sqrt(yvar*(this._max_proj_y - this._min_proj_y));
                    // console.log(total_var);
                    // if (total_var <= 0.5) {
                    //     return [x, y];
                    // }
                    
                    return [x, y];
                }
            } 

            return false; 
        },

        // 線形的な変換のある時
        _mercy2y: function(merc_y) { 
            return merc_y * this._linear_transformation[2] + this._linear_transformation[3];     
        },
        _y2mercy: function(y) { 
            return (y - this._linear_transformation[3]) / this._linear_transformation[2]; 
        },
        _mercx2x: function(merc_x) {  
            return merc_x * this._linear_transformation[0] + this._linear_transformation[1]; 
        },
        _x2mercx: function(x) { 
            return (x - this._linear_transformation[1]) / this._linear_transformation[0];
        },

        has_elevation: function() {
            return false;
        }, 
        get_elevation: function(x, y) {  
            // 最も近い基準点の4つを選ぶ
            var nearest_pts = [];
            var i;
            for(i = 0; i < this._elevations.length; i++) {
                var vp_x = this._elevations[i][0];
                var vp_y = this._elevations[i][1];

                var distance = Math.sqrt(Math.pow((x - vp_x), 2.0) + Math.pow((y - vp_y), 2.0));
                nearest_pts.push({
                    index: i,
                    distance: distance
                });
            }
            nearest_pts.sort(function(a,b) {
                return a.distance < b.distance ? -1 : a.distance > b.distance ? 1 : 0;
            });
            nearest_pts = nearest_pts.slice(0,4);

            var A = [];
            var b = [];
            for (i = 0; i < nearest_pts.length; i++) {
                var ref_pt = this._elevations[nearest_pts[i].index]; 
                var ref_x = ref_pt[0];
                var ref_y = ref_pt[1];
                var ref_elevation = ref_pt[2];
                A.push([1, ref_x, ref_y, ref_x*ref_y]);
                b.push(ref_elevation);
            } 
            var coefficients = _Linear._solve(A, b); 
            var interpolated_elevation = coefficients[0] + coefficients[1]*x + coefficients[2]*y + coefficients[3]*x*y; 
            
            return interpolated_elevation;
        },  
        geodesic_distance: function(lat1, lon1, lat2, lon2) {
            var R = 6371e3; // 地球の半径[m]（平均）
    
            // Haversine formula
            // source: https://www.movable-type.co.uk/scripts/latlong.html
            var phi_1 = lat1 / this._RAD2DEG;
            var phi_2 = lat1 / this._RAD2DEG;
            var delta_phi = (lat2 - lat1) / this._RAD2DEG;
            var delta_lambda = (lon2 - lon1) / this._RAD2DEG;
    
            var sin_deltaphi2 = Math.sin(delta_phi/2);
            var cos_deltalambda2 = Math.sin(delta_lambda/2);
            var a = Math.pow(sin_deltaphi2, 2.0) + Math.cos(phi_1) * Math.cos(phi_2) * Math.pow(cos_deltalambda2, 2.0);
            var c = Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    
            var d = 2.0 * R * c;
    
            return d;
        },
        estimate_size: function(viewport_location, viewport_size) {
            var lonlat = this.vp2lonlat(viewport_location.x, viewport_location.y);
            var lonlat_delta = this.vp2lonlat(viewport_location.x+viewport_size, viewport_location.y+viewport_size);

            return this.geodesic_distance(lonlat[1], lonlat[0], lonlat_delta[1], lonlat_delta[0]);
        },

        // JSONにエクスポートするために必要なデータだけを残す
        _reduce_variogram: function(variogram) {
            var reduced_variogram = {};

            reduced_variogram.A = variogram.A;
            // reduced_variogram.K = variogram.K;
            reduced_variogram.M = variogram.M;
            reduced_variogram.n = variogram.n;
            reduced_variogram.nugget = variogram.nugget;
            reduced_variogram.range = variogram.range;
            reduced_variogram.sill = variogram.sill;

            return reduced_variogram;
        },

        _save: function() {
            this._train();

            var obj = [];
            obj.push(this._x_coordinates);
            obj.push(this._y_coordinates);
            obj.push(this._proj_x_coordinates);
            obj.push(this._proj_y_coordinates);

            obj.push(this._reduce_variogram(this._xy2mercx_model));
            obj.push(this._reduce_variogram(this._xy2mercy_model));
            obj.push(this._reduce_variogram(this._mercxy2x_model));
            obj.push(this._reduce_variogram(this._mercxy2y_model)); 
            obj.push(this._variogram_model);

            return obj;
        },


        _restore: function(obj) {
            var start_index = 0;
            if (obj.length == 11) { 
                this._min_proj_x = obj[0][0];
                this._max_proj_x = obj[0][1];
                this._min_proj_y = obj[1][0];
                this._max_proj_y = obj[1][1];

                start_index = 2;
                this._x_coordinates = obj[start_index+0];
                this._y_coordinates = obj[start_index+1];
                this._proj_x_coordinates = obj[start_index+2];
                this._proj_y_coordinates = obj[start_index+3];

                var i;
                for (i = 0; i < this._proj_x_coordinates.length; i++) {
                    this._proj_x_coordinates[i] = this._unscale(this._proj_x_coordinates[i], this._min_proj_x, this._max_proj_x);
                }
                for (i = 0; i < this._proj_y_coordinates.length; i++) {
                    this._proj_y_coordinates[i] = this._unscale(this._proj_y_coordinates[i], this._min_proj_y, this._max_proj_y);
                } 
            }
            else {
                this._x_coordinates = obj[start_index+0];
                this._y_coordinates = obj[start_index+1];
                this._proj_x_coordinates = obj[start_index+2];
                this._proj_y_coordinates = obj[start_index+3];
            }


            this._estimate_bounds();

            this._xy2mercx_model = obj[start_index+4];
            this._xy2mercx_model.t = this._proj_x_normalized;
            this._xy2mercx_model.x = this._x_coordinates;
            this._xy2mercx_model.y = this._y_coordinates;

            this._xy2mercy_model = obj[start_index+5];
            this._xy2mercy_model.t = this._proj_y_normalized;
            this._xy2mercy_model.x = this._x_coordinates;
            this._xy2mercy_model.y = this._y_coordinates;

            this._mercxy2x_model = obj[start_index+6];
            this._mercxy2x_model.t = this._x_coordinates;
            this._mercxy2x_model.x = this._proj_x_normalized;
            this._mercxy2x_model.y = this._proj_y_normalized;

            this._mercxy2y_model = obj[start_index+7];
            this._mercxy2y_model.t = this._y_coordinates;
            this._mercxy2y_model.x = this._proj_x_normalized;
            this._mercxy2y_model.y = this._proj_y_normalized;

            this._variogram_model = obj[start_index+8];

            // 関数を入れる
            this._xy2mercx_model = $.gp.load(this._variogram_model, this._xy2mercx_model);
            this._xy2mercy_model = $.gp.load(this._variogram_model, this._xy2mercy_model);
            this._mercxy2x_model = $.gp.load(this._variogram_model, this._mercxy2x_model);
            this._mercxy2y_model = $.gp.load(this._variogram_model, this._mercxy2y_model);

            
        },

        _normalize_projected_coordinates: function() { 
            this._proj_x_normalized = [];
            this._proj_y_normalized = [];

            this._proj_x_coordinates.forEach(function(_, index) { 
                this._proj_x_normalized.push(this._scale(this._proj_x_coordinates[index], this._min_proj_x, this._max_proj_x));
                this._proj_y_normalized.push(this._scale(this._proj_y_coordinates[index], this._min_proj_y, this._max_proj_y));
            }, this);
        },

        _estimate_bounds: function() {
            // viewport 
            this._min_x = Math.min.apply(this, this._x_coordinates);
            this._min_y = Math.min.apply(this, this._y_coordinates);
            this._max_x = Math.max.apply(this, this._x_coordinates);
            this._max_y = Math.max.apply(this, this._y_coordinates);
            this._vp_bounding_rect = new OpenSeadragon.Rect(
                this._min_x, this._min_y, this._max_x - this._min_x, this._max_y - this._min_y);
            
            // projected
            this._min_proj_x = Math.min.apply(this, this._proj_x_coordinates);
            this._min_proj_y = Math.min.apply(this, this._proj_y_coordinates);
            this._max_proj_x = Math.max.apply(this, this._proj_x_coordinates);
            this._max_proj_y = Math.max.apply(this, this._proj_y_coordinates);
            this._proj_bounding_rect = new OpenSeadragon.Rect(
                this._min_proj_x, this._min_proj_y, this._max_proj_x - this._min_proj_x, this._max_proj_y - this._min_proj_y);

            this._normalize_projected_coordinates();
        },

        check_bounds_viewport: function(x,y) {
            var pt = new OpenSeadragon.Point(x,y);
            // todo make tolerance configurable
            return this._is_in_rect_tolerance(pt, this._vp_bounding_rect, 0.1);
        },

        check_bounds_gps: function(lon,lat) {
            if (this._has_linear_transformation) {
                return true;
            }

            if (this._projection) {
                var merc_xy = this._projection.forward([lon, lat]);
                var merc_pt = new OpenSeadragon.Point(merc_xy[0], merc_xy[1]);
                // 10% of bounding rect width of tolerance
                // todo make it configurable
                return this._is_in_rect_tolerance(merc_pt, this._proj_bounding_rect, 0.1);
            }

            return false;
        },

        _is_in_rect_tolerance: function(pt, rect, tolerance_factor) {
            var size = Math.max.apply(this, [rect.width, rect.height]);
            var tolerance = size*tolerance_factor;
            return rect.containsPoint(pt, tolerance);
        },

        _train: function() {
            this._estimate_bounds();

            this._variogram_model = "exponential";
            var sigma2 = 0, alpha = 1;
            this._xy2mercx_model = $.gp.train(this._proj_x_normalized, this._x_coordinates, this._y_coordinates, this._variogram_model, sigma2, alpha);
            this._xy2mercy_model = $.gp.train(this._proj_y_normalized, this._x_coordinates, this._y_coordinates, this._variogram_model, sigma2, alpha);
            this._mercxy2x_model = $.gp.train(this._x_coordinates, this._proj_x_normalized, this._proj_y_normalized, this._variogram_model, sigma2, alpha);
            this._mercxy2y_model = $.gp.train(this._y_coordinates, this._proj_x_normalized, this._proj_y_normalized, this._variogram_model, sigma2, alpha);
            this._has_nlint_data = true;
        },

        _scale: function(value, interval_min, interval_max) {
            return (value - interval_min) / (interval_max - interval_min);
        },
        _unscale: function(value, interval_min, interval_max) {
            return ( value * (interval_max - interval_min) ) + interval_min;
        },  

        _load_from_lint_data: function(lint_data) {
            this._has_lint_data = true;
            this._viewport_coordinates = lint_data[0];
            this._mercator_coordinates = lint_data[1];

            // 学習配列の準備
            this._x_coordinates = [];
            this._y_coordinates = []; 
            this._viewport_coordinates.forEach(function(element) {
                this._x_coordinates.push(element[0]);
                this._y_coordinates.push(element[1]);
            }, this); 

            this._proj_x_coordinates = [];
            this._proj_y_coordinates = [];
            this._mercator_coordinates.forEach(function(element) {
                this._proj_x_coordinates.push(element[0]);
                this._proj_y_coordinates.push(element[1]);
            }, this);

            this._estimate_bounds();
            // this._set_projected_coordinates_bounds();
            
            
            this._train();
        },
 

        _reset: function() {
            this._x_coordinates = [];
            this._y_coordinates = [];
            this._proj_x_coordinates = [];
            this._proj_y_coordinates = [];
            this._proj_x_normalized = [];
            this._proj_y_normalized = [];
            this._mercator_coordinates = [];
            this._viewport_coordinates = [];
        },

        getProjection: function() {
            return this._projection;
        },

    }, $.Tracker);
})(ABDOMap);

